import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, User } from 'react-feather';
import man from '../../../assets/images/dashboard/profile.png';
import { logoutUser } from '../../../Services/authService';

import { LI, UL, P } from '../../../AbstractElements';

const UserHeader = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('');

  useEffect(() => {
    const updateUserData = () => {
      setProfile(localStorage.getItem('profileURL') || man);
      const storedName = localStorage.getItem('userFullName');
      setName(storedName || 'Kullanıcı');
      const storedRole = localStorage.getItem('userRole');
      setRole(storedRole || 'Kullanıcı');
    };

    // Initial load
    updateUserData();

    // Listen for role changes
    const handleRoleChange = () => {
      updateUserData();
    };

    window.addEventListener('userRoleChanged', handleRoleChange);

    return () => {
      window.removeEventListener('userRoleChanged', handleRoleChange);
    };
  }, []);

  const Logout = () => {
    logoutUser();
    navigate(`${process.env.PUBLIC_URL || ''}/login`);
  };

  const handleAccountNavigation = () => {
    navigate(`/accounts/my-account`);
  };

  return (
    <li className='profile-nav onhover-dropdown pe-0 py-0'>
      <div className='media profile-media'>
        <div className='media-body'>
          <span>{name}</span>
          <P attrPara={{ className: 'mb-0 font-roboto' }}>
            {role}
            <i className='middle fa fa-angle-down'></i>
          </P>
        </div>
      </div>
      <UL attrUL={{ className: 'simple-list profile-dropdown onhover-show-div' }}>
        {/*
        <LI attrLI={{ onClick: handleAccountNavigation }}>
          <User />
          <span>Hesabım</span>
        </LI>
        */}
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>Çıkış</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
